import { post } from '../../common/ApiClient';
import { UserNameUpdate, UsernameResponse, UserInfoResponse } from '../types/User';
import { appendIfNotFalsy } from '../../utils/appendFormData';

export const getUserInfo = async () => {
  try {
    const { data } = await post<UserInfoResponse>('/user/info', true);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserName = async (userData: UserNameUpdate): Promise<UsernameResponse> => {
  try {
    let formData = new FormData();
    appendIfNotFalsy(formData, 'first_name', userData.firstName);
    appendIfNotFalsy(formData, 'last_name', userData.lastName);
    appendIfNotFalsy(formData, 'userId', userData.userId.toString());
    appendIfNotFalsy(formData, 'prevAvatarUrl', userData.prevAvatarUrl);
    appendIfNotFalsy(formData, 'avatar', userData.avatar);

    const { data } = await post<UsernameResponse>('/user/change-profile', true, formData);

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
